import RichText from "@/components/atoms/rich-text/rich-text";

import { useContactDetailsContext } from "../../../provider/contact-details.provider";
import { formCmsData } from "../../../utils/contact-details-page.util";

function ContactDetilasPolicyDescription() {
  const { cmsData } = useContactDetailsContext();
  const { privacyPolicyDescription } = formCmsData(cmsData);

  return (
    <div className="md:mt-spacing-m mt-spacing-l">
      {privacyPolicyDescription && (
        <RichText
          richText={privacyPolicyDescription}
          className="text-[14px] break-words font-body-font leading-[21px] text-text-body contact-rich-text"
        />
      )}
    </div>
  );
}
export default ContactDetilasPolicyDescription;
